import { Typography } from "@lyfegen-platform/react-common";
import { Collapse, Divider, IconButton, Link, useTheme } from "@material-ui/core";
import { ArrowDropDown, ArrowDropUp } from "@material-ui/icons";
import { LiteBox } from "apps/platform-client/client/src/components/lite/LiteBox";
import { useState } from "react";
import { useHistory } from "react-router";

interface IDomainDividerProps {
	title: string;
	id: string;
	AddSubdomainButtonComponent: React.ComponentType<{ parentDomainId: string }>;
	content?: JSX.Element;
	counterSection?: JSX.Element;
}

const ProductDomainDivider = (props: IDomainDividerProps) => {
	const { title, id, content, AddSubdomainButtonComponent, counterSection } = props;
	const [open, setOpen] = useState(!!content);
	const { push } = useHistory();
	const {
		palette: {
			widgetHeaderText: { main },
		},
		typography: { pxToRem },
	} = useTheme();

	const handleClick = () => {
		setOpen(!open);
	};

	const handleProductDomainClick = (e: React.SyntheticEvent) => {
		e.preventDefault();
		push(`/organization-settings/domains/${id}`);
	};

	return (
		<LiteBox paddingLeft={"24px"} marginBottom={1}>
			<LiteBox width="100%" display="flex">
				<LiteBox width="100%" display="flex" justifyContent="space-between" alignItems="center">
					{!!content && (
						<IconButton color="inherit" size="small" onClick={handleClick}>
							{open ? <ArrowDropUp /> : <ArrowDropDown />}
						</IconButton>
					)}
					<Link underline="none" onClick={handleProductDomainClick} style={{ cursor: "pointer" }}>
						<Typography type="h7" style={{ fontWeight: 500, textTransform: "unset" }} color="primary">
							{title}
						</Typography>
					</Link>
					<Divider style={{ flexGrow: 1, margin: pxToRem(15), backgroundColor: main }} />
					<AddSubdomainButtonComponent parentDomainId={id} />
				</LiteBox>
			</LiteBox>
			{counterSection}
			<Collapse in={open}>{content}</Collapse>
		</LiteBox>
	);
};

export default ProductDomainDivider;
